// Hyphens and spaces are interchangeable so "bounty hunter" finds the "bounty-hunter" keyword
export function normalizeSearchText(text){
    return (text || '').toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
}

export function parseSearch(text){
    return (text || '').split(',').map(normalizeSearchText).filter(Boolean);
}

// Every comma-separated part has to match the name or a keyword
export function matchCharacter(character, searchParts){
    const name = normalizeSearchText(character.name);
    const terms = character.searchTerms.map(normalizeSearchText);
    return searchParts.every(part => name.includes(part) || terms.some(term => term.includes(part)));
}

export function passesFilters(character, { collectingOnly = false, media = [] } = {}){
    if (collectingOnly && !character.collected){
        return false;
    }
    if (media.length && !media.some(m => character.media.includes(m))){
        return false;
    }
    return true;
}

const byName = (a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });

export function sortCharacters(characters, sortKey){
    const sorted = [...characters];
    if (sortKey === 'cards'){
        sorted.sort((a, b) => (b.totalCards - a.totalCards) || byName(a, b));
    }
    else if (sortKey === 'sketches'){
        sorted.sort((a, b) => (b.sketchCount - a.sketchCount) || byName(a, b));
    }
    else {
        sorted.sort(byName);
    }
    return sorted;
}

export function letterFor(name){
    const first = (name || '').trim().charAt(0).toUpperCase();
    return /[A-Z]/.test(first) ? first : '#';
}

// Characters the user collected when the page loaded go first; A–Z also splits the rest by letter
export function groupCharacters(characters, { sortKey, pinnedIds = new Set() } = {}){
    const groups = [];
    const pinned = characters.filter(c => pinnedIds.has(c.id));
    const rest = characters.filter(c => !pinnedIds.has(c.id));

    if (pinned.length){
        groups.push({ id: 'yours', label: 'Your characters', jumpLabel: 'Yours', items: pinned });
    }

    if (sortKey === 'name'){
        const byLetter = new Map();
        rest.forEach(c => {
            const letter = letterFor(c.name);
            if (!byLetter.has(letter)){
                byLetter.set(letter, []);
            }
            byLetter.get(letter).push(c);
        });
        [...byLetter.keys()]
            .sort((a, b) => (a === '#') - (b === '#') || a.localeCompare(b))
            .forEach(letter => {
                const id = letter === '#' ? 'other' : letter.toLowerCase();
                groups.push({ id, label: letter, jumpLabel: letter, items: byLetter.get(letter) });
            });
    }
    else if (rest.length){
        groups.push({ id: 'all', label: pinned.length ? 'Other characters' : null, jumpLabel: null, items: rest });
    }
    return groups;
}

export function collectMediaValues(characters){
    const values = new Set();
    characters.forEach(c => c.media.forEach(m => values.add(m)));
    return [...values].sort((a, b) => a.localeCompare(b));
}
